import type { Deck } from "@hali-shares/deck-schema";
import { layoutKey } from "../context";
import { DETAIL, type FlowLayout, TOP_LEVEL, layoutFlow } from "./layout";

/** Lay out every flow and sub-flow in the deck up front, so slides never wait on ELK mid-talk. */
export async function layoutDeck(deck: Deck): Promise<Map<string, FlowLayout>> {
  const jobs: Promise<[string, FlowLayout]>[] = [];
  for (const section of deck.sections)
    for (const block of section.blocks) {
      if (block.type !== "flow") continue;
      jobs.push(layoutFlow(block.nodes, block.edges, TOP_LEVEL, block.loopLabel).then((l) => [layoutKey(block.id), l]));
      for (const node of block.nodes) {
        const sub = node.detail?.flow;
        if (sub) jobs.push(layoutFlow(sub.nodes, sub.edges, DETAIL).then((l) => [layoutKey(block.id, node.id), l]));
      }
    }
  return new Map(await Promise.all(jobs));
}
